import { RECUPERAR_SENHA, RecuperarSenhaState, RecuperarSenhaActionTypes } from '../../types/recuperarSenha/recuperarSenha';

const initialState: RecuperarSenhaState = {
  validationResult: null
};

export function RecuperarSenhaReducer(
  state = initialState,
  action: RecuperarSenhaActionTypes
): RecuperarSenhaState {
  switch (action.type) {
    case RECUPERAR_SENHA:
      return {
        ...state,
        validationResult: action.payload
      };
    default:
      return state;
  }
}